<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <lote-titulo-editar-form @success="success"></lote-titulo-editar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <lote-titulo-editar-form @success="success"></lote-titulo-editar-form>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'lote-titulo-editar-form': require('./LoteTituloEditarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
